<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="lot.numLot"
[label]="step4.getnumlot"
[type]="'number'" [rule]="'min_0|max_999|required'"
[errorMessage]="{'required' : 'ctr_150', 'max': 'ctr_965'}"
[name]="getUid()+'_SepAtt_numLot'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="lot.description"
[label]="step4.getdescription"
[type]="'text'"
[rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_151', 'minLength':'ctr_153'}"
[name]="getUid()+'_SepAtt_description'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="lot.infosComplementaires"
[label]="step4.getinfocomplementaires"
[type]="'text'" [rule]="'minSize_5|maxSize_255'" [errorMessage]="{'pattern' : 'ctr_1436'}"
[name]="getUid()+'_SepAtt_infoComplementaires'">
</app-form-input>
